// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Mogyb","left":"styles_left__1Jub2","desktopActions":"styles_desktopActions__5NV7f","title":"styles_title__1sCuv"};